import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/tampa3.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image121.webp';
import slideImg2 from '../images/image117.webp';
import slideImg3 from '../images/image50.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const belleairBeachConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Belleair Beach Tree Service | Sam\'s Tree Service',
  metaDescription: 'Professional tree trimming and removal in Belleair Beach, FL. Sam\'s Tree Service handles dangerous trees safely and affordably.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_belleair_beach',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Belleair Beach',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Belleair Beach Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we understand what it takes to maintain 
     trees on the premium waterfront properties of <strong>Belleair Beach</strong>. 
     This exclusive Gulf front community has high standards and so do we. Overgrown 
     canopies blocking Gulf views, storm-damaged palms leaning toward luxury homes, 
     and aging oaks threatening seawalls and driveways all require experienced, 
     careful handling. Our team delivers that on every job.`,

    `We specialize in <strong>precision tree removal and trimming on high value 
     coastal properties</strong> working carefully around landscaping, pools, 
     docks, and structures to eliminate hazards without causing unnecessary damage. 
     Storm weakened trunks, overhanging limbs, and salt damaged canopies are all 
     situations we assess and resolve safely and professionally.`,

    `<strong>Sam's Tree Service</strong> provides expert, reliable tree care 
     throughout <strong>Belleair Beach</strong> and the surrounding 
     <strong>Pinellas barrier island</strong> communities protecting the beauty 
     and value of your property through every season.`,
  ],

  ctaLabel: 'Get a Free Estimate!',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Belleair Beach, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_BelleairBeach = () => <LocationPage config={belleairBeachConfig} />;
export default Services_BelleairBeach;
